





































































































import Component, { mixins } from "vue-class-component";
import TextMonthChangePicker from "../common/TextMonthChangePicker.vue";
import TextDayChangePicker from "../common/TextDayChangePicker.vue";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit, Ref } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";
import VuetifyNumberInput from "../common/VuetifyNumberInput.vue";
import { CareSpecificationDetail, CareService } from "./types";
import CareServiceDialog from "./CareServiceDialog.vue";

@Component({
  components: {
    TextMonthChangePicker,
    TextDayChangePicker,
    LoadingDialog,
    CareServiceDialog,
    VuetifyNumberInput
  }
})
export default class DetailEditDialog extends mixins(AxiosMixin) {
  private specificationDetail: CareSpecificationDetail | null = null;
  private isActive = false;
  private isDelete = false;
  @Ref("serviceDialog") private readonly serviceDialog!: CareServiceDialog; //介護サービス検索ダイアログ

  private get Points(): number {
    if (this.specificationDetail === null) {
      return 0;
    } else {
      return this.specificationDetail.points;
    }
  }

  private set Points(value: number) {
    if (this.specificationDetail) {
      this.specificationDetail.points = value;
      if (this.Count) {
        this.specificationDetail.service_points = value * this.Count;
      }
      if (this.PublicMoneyCount) {
        this.specificationDetail.public_money_points =
          value * this.PublicMoneyCount;
      }
    }
  }

  private get Count(): number {
    if (this.specificationDetail === null) {
      return 0;
    } else {
      return this.specificationDetail.count;
    }
  }

  private set Count(value: number) {
    if (this.specificationDetail) {
      this.specificationDetail.count = value;
      if (this.Points) {
        this.specificationDetail.service_points = this.Points * value;
      }
    }
  }

  private get PublicMoneyCount(): number {
    if (this.specificationDetail === null) {
      return 0;
    } else {
      return this.specificationDetail.public_money_count;
    }
  }

  private set PublicMoneyCount(value: number) {
    if (this.specificationDetail) {
      this.specificationDetail.public_money_count = value;
      if (this.Points) {
        this.specificationDetail.public_money_points = this.Points * value;
      }
    }
  }

  public open(
    careSpecificationId: number,
    yearmonth: string,
    officeIbowUniqueId: number
  ) {
    this.specificationDetail = {
      id: 0,
      care_specification_id: careSpecificationId,
      yearmonth: yearmonth,
      office_ibow_unique_id: officeIbowUniqueId,
      service_name: "",
      service_code: 0,
      points: 0,
      count: 0,
      service_points: 0,
      public_money_count: 0,
      public_money_points: 0,
      summary: "",
      out_management_div: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
    this.isActive = true;
    this.isDelete = true;
  }

  public openUpdate(specificationDetail: CareSpecificationDetail) {
    this.specificationDetail = Object.assign({}, specificationDetail);
    this.isActive = true;
    this.isDelete = false;
  }

  private clickDelete() {
    if (confirm("編集中の明細行を削除します。よろしいですか？")) {
      this.delete();
      this.isActive = false;
    }
  }

  private clickOk() {
    if (confirm("編集中の明細行を介護給付費に反映します。よろしいですか？")) {
      this.update();
      this.isActive = false;
    }
  }

  private clickCancel() {
    this.isActive = false;
  }

  //サービス検索
  private clickSearchService() {
    if (this.specificationDetail !== null) {
      let serviceCode = "";
      if (this.specificationDetail.service_code === 0) {
        serviceCode = "";
      } else {
        serviceCode = String(this.specificationDetail.service_code);
      }
      this.serviceDialog.open(
        this.specificationDetail.yearmonth,
        serviceCode,
        this.specificationDetail.service_name
      );
    }
  }

  //サービス選択
  private selectService(careService: CareService) {
    if (this.specificationDetail !== null) {
      this.specificationDetail.service_code = Number(
        careService.kind_service_code
      );
      this.specificationDetail.service_name = careService.service_name;
      this.specificationDetail.points = careService.point;
      this.specificationDetail.out_management_div =
        careService.out_management_div;
    }
  }

  @Emit()
  update() {
    return this.specificationDetail;
  }

  @Emit()
  delete() {
    return;
  }
}
